import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "nc_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener("nc:open-cookie-consent", reopen);
    return () => window.removeEventListener("nc:open-cookie-consent", reopen);
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6"
      data-testid="cookie-consent-banner"
    >
      <div
        className="max-w-[1100px] mx-auto surface p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-5"
        style={{
          background:
            "linear-gradient(120deg, rgba(74,14,62,0.55), rgba(10,5,13,0.92))",
          backdropFilter: "blur(16px)",
          border: "1px solid rgba(232,180,184,0.22)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.55)",
        }}
      >
        <div className="flex items-start gap-3 flex-1">
          <div
            className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center border"
            style={{ borderColor: "rgba(232,180,184,0.4)" }}
          >
            <Cookie size={16} style={{ color: "var(--gold)" }} />
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            This site uses cookies for analytics and ad personalization
            (Google AdSense) to keep the work independent. See our{" "}
            <Link
              to="/privacy"
              className="text-[color:var(--gold)] hover:underline"
              data-testid="cookie-consent-privacy-link"
            >
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => decide("declined")}
            className="text-xs uppercase tracking-[0.22em] text-white/55 hover:text-white/80 transition px-3 py-2"
            data-testid="cookie-consent-decline"
          >
            Decline
          </button>
          <button
            onClick={() => decide("accepted")}
            className="btn-gold rounded-none px-6 h-10 text-xs whitespace-nowrap"
            data-testid="cookie-consent-accept"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
